import { clientsSaga } from 'modules/client/store/clients';
import contactsSaga from 'modules/contact/store/contacts-saga';
import customerSaga from 'modules/customer/store/customers-saga';
import customerSelectSaga from 'modules/customer/store/customerSelect-saga';
import inboxSaga from 'modules/inbox/store/inbox-saga';
import { requestsSaga } from 'modules/request/store/request';
import { requestTimelogSaga } from 'modules/request/store/requestTimelog';
import { tasksSaga } from 'modules/tasks/store/task';
import { taskTimelogReportSaga } from 'modules/tasks/store/taskTimelogReport';
import { projectTasksSaga as tableProjectTasksSaga } from 'modules/project/store/projectTasks';
import { projectTasksTimelogSaga } from 'modules/project/store/projectTasksTimelog';
import { projectRequestsSaga } from 'modules/project/store/projectRequests';
import { projectCreditsSaga } from 'modules/project/store/projectCredits';
import { projectCreditHistorySaga } from 'modules/project/store/projectCreditHistory';
import { projectBudgetReportSaga } from 'modules/project/store/projectBudgetReport';
import { projectsSaga } from 'modules/project/store/project';
import { projectsTimeReportSaga } from 'modules/projectTimeReport/store/projectTimeReport';
import projectSelectSaga from 'modules/project/store/projectSelect-saga';
import reportUserPerformanceSaga from 'modules/report/store/reportUserPerformance-saga';
import groupsSaga from 'modules/groups/store/groups-saga';
import contentSaga from 'modules/content/store/content-saga';
import { timelogReportSaga } from 'modules/timelogReport/store/timelogReport';
import { profileTimelogSaga } from 'modules/contact/store/profileTimelog';
import {
  profileClockReportSaga,
  profileTaskOverdueSaga,
  profileRequestOverdueSaga,
} from 'modules/contact/store/profileReports';
import { projectTimelogReportSaga } from 'modules/project/store/projectTimelogReport';
import dashboardFailedPaymentsSaga from 'modules/dashboard/store/dashboardFailedPayments-saga';
import dashboardUserPerformanceSaga from 'modules/dashboard/store/dashboardUserPerformance-saga';
import { dashboardTasksSaga } from 'modules/dashboard/store/dashboardTasks';
import { requestsExportSaga } from 'modules/request/store/requestExport';

import { all, fork } from 'redux-saga/effects';

import activeLogsSaga from './container/activeLogs/activeLogs-sagas';
import weeklyLogsSaga from './container/weeklyLogs/weeklyLogs-sagas';
import authSaga from './container/auth/auth-sagas';
import teamActivitySaga from './container/teamActivity/teamActivity-sagas';
import teamTaskActivitySaga from './container/teamTaskActivity/teamTaskActivity-sagas';

export default function* root() {
  yield all([
    fork(contactsSaga),
    fork(customerSaga),
    fork(customerSelectSaga),
    fork(clientsSaga),
    fork(authSaga),
    fork(groupsSaga),
    fork(requestsSaga),
    fork(requestsExportSaga),
    fork(requestTimelogSaga),
    fork(tasksSaga),
    fork(taskTimelogReportSaga),
    fork(tableProjectTasksSaga),
    fork(projectRequestsSaga),
    fork(projectsSaga),
    fork(projectsTimeReportSaga),
    fork(projectTasksTimelogSaga),
    fork(projectCreditsSaga),
    fork(projectCreditHistorySaga),
    fork(projectBudgetReportSaga),
    fork(projectSelectSaga),
    fork(reportUserPerformanceSaga),
    fork(inboxSaga),
    fork(activeLogsSaga),
    fork(weeklyLogsSaga),
    fork(teamActivitySaga),
    fork(teamTaskActivitySaga),
    fork(timelogReportSaga),
    fork(profileTimelogSaga),
    fork(profileClockReportSaga),
    fork(profileTaskOverdueSaga),
    fork(profileRequestOverdueSaga),
    fork(projectTimelogReportSaga),
    fork(contentSaga),
    fork(dashboardFailedPaymentsSaga),
    fork(dashboardUserPerformanceSaga),
    fork(dashboardTasksSaga),
  ]);
}
